import { combineReducers } from "redux";
import { configuratorReducer } from "./configurator-store";
import { addEditLabelReducer } from "./components/add-edit-label/add-edit-label-store";
import { addEditConfigurationDialogReducer } from "./components/add-edit-configuration-dialog/add-edit-configuration-dialog-store";
import { productInformationDialogReducer } from "./components/product-information-dialog/product-information-dialog-store";
import { filterReducer } from "./components/filter/filter-store";
import { viewSettingsReducer } from "./components/view-settings/view-settings-store";

export const combinedConfiguratorReducer = combineReducers({
  configuratorReducer,
  addEditLabelReducer,
  addEditConfigurationDialogReducer,
  productInformationDialogReducer,
  filterReducer,
  viewSettingsReducer
});
